const Total = (props: { total: number }) => {
    const { total } = props
    return (
        <div className="pagination-total">
            مجموع: <span>{total}</span> مورد
        </div>
    )
}

export default Total
